<template>
  <div>
    <ReactWrapper :component="CalibrationPanel" :props="props" />
  </div>
</template>

<script>
  import { CalibrationPanel } from '../../../../../frontendV2/dist/reactComponents';
  import ReactWrapper from '@/components/blocks/reactComponents/ReactWrapper';

  export default {
    name: 'CalibrationPanel',

    components: {
      ReactWrapper,
    },

    data: () => ({
      CalibrationPanel,
    }),

    props: {
      sequenceId: {
        type: Number,
        required: true,
      },
      defaultExpanded: {
        type: Boolean,
        default: true,
      },
      calibrationId: {
        type: Number,
        default: null,
      },
    },

    computed: {
      props() {
        return {
          sequenceId: this.sequenceId,
          defaultExpanded: this.defaultExpanded,
          calibrationId: this.calibrationId,
          onShowMeasurement: this.handleShowMeasurement,
          onShowStandard: this.handleShowStandard,
          onChangeCalibration: this.handleChangeCalibration,
        };
      },
    },

    methods: {
      handleShowMeasurement(id) {
        this.$emit('showMeasurement', id);
      },
      handleShowStandard(standardId) {
        this.$emit('showStandard', standardId);
      },
      handleChangeCalibration(calibrationId) {
        this.$emit('changeCalibration', calibrationId);
      },
    },
  };
</script>
